import { render, staticRenderFns } from "./domain-setting.vue?vue&type=template&id=13233e2e&"
import script from "./domain-setting.vue?vue&type=script&lang=ts&"
export * from "./domain-setting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports